// src/pages/public/RecoverStep1.jsx
// FASE 3.6 — flujo simplificado: el reset real ocurre en /auth/action
// (link directo en el email Resend). Esta pantalla solo captura el email
// y dispara el callable sendPasswordResetEmailFn vía resetPassword().
// Tras el envío, redirige a /recuperar/enviado con el email en state.
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { resetPassword, authErrorMessage } from '../../auth/authHelpers';
import { AuthBack, AuthLogo, Field, ErrorBanner } from './_authShared';

export default function RecoverStep1() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async () => {
    if (loading || !email) return;
    setError('');
    setLoading(true);
    const cleanEmail = email.trim();
    try {
      await resetPassword(cleanEmail);
      navigate('/recuperar/enviado', { state: { email: cleanEmail } });
    } catch (err) {
      setError(authErrorMessage(err));
      setLoading(false);
    }
  };

  return (
    <div className="mobile-root">
      <section className="screen" style={{ paddingTop: 28, paddingBottom: 40 }}>
        <AuthBack onClick={() => navigate('/login')} />
        <AuthLogo />
        <div className="screen-head">
          <h2>Recupera tu contraseña</h2>
          <p>Ingresa el email con el que creaste tu cuenta. Te enviaremos un enlace.</p>
        </div>
        <ErrorBanner msg={error} />
        <div className="input-group">
          <Field
            label="Email"
            type="email"
            placeholder="tu@email.com"
            value={email}
            onChange={setEmail}
            autoComplete="email"
          />
        </div>
        <button
          className="btn-primary accent"
          style={{ marginTop: 22, opacity: loading ? 0.5 : 1, pointerEvents: loading ? 'none' : 'auto' }}
          onClick={handleSubmit}
        >
          {loading ? 'Enviando...' : 'Enviar enlace'}
        </button>
        <div style={{ textAlign: 'center', marginTop: 22, fontSize: 13, color: 'var(--muted)' }}>
          ¿La recordaste?{' '}
          <a
            onClick={() => navigate('/login')}
            style={{ color: 'var(--ink)', fontWeight: 600, textDecoration: 'underline', cursor: 'pointer' }}
          >
            Volver al login
          </a>
        </div>
      </section>
    </div>
  );
}
